<template lang="pug">
  #ReservationEdit.container-width
    h5.text-center.pt-2 CA編輯
    .p-3
      .mb-2
        .row.align-items-center.mb-3.no-gutters
          .col-6.pr-1
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
              :profileUrl="sa_info.picture_url",
              :style="{ 'width': '80px', 'height': '80px' }"
            )
          .col-6.pl-1
            p.mb-0.font-weight-bold 姓名 {{ `${sa_info.chinese_last_name} ${sa_info.chinese_first_name}` }}
            p.mb-0 員工編號：{{ sa_info.sa_code }}
        h5.text-center.mb-3 變更CA狀態
        b-row.mb-3(
          no-gutters
        )
          b-col(
            cols="6",
            class="pr-1"
          )
            b-button(
              :variant="nowSelectStatus === 'resign' ? 'primary' : 'outline-primary'",
              block,
              @click="nowSelectStatus = 'resign'"
            ) 離職
          b-col(
            cols="6",
            class="pl-1"
          )
            b-button(
              :variant="nowSelectStatus === 'leave_without_pay' ? 'primary' : 'outline-primary'",
              block,
              @click="nowSelectStatus = 'leave_without_pay'"
            ) 解除綁定
        h5.text-center.mb-3 移轉客戶至指定CA
        multiselect.mb-3(
          v-model="selectSa",
          tag-placeholder="輸入搜尋CA",
          placeholder="請選擇CA",
          selectedLabel="已選擇",
          selectLabel="點擊選擇CA",
          label="preferred_name",
          track-by="sa_id"
          :options="storePersonnel",
          :allow-empty="false"
          :close-on-select="true",
          :deselectLabel="''",
          noOptions="無CA"
        )
          template(slot="noOptions")
            strong 無CA
          template(slot="noResult")
            strong 無CA
      .px-4
        .row
          .col-6
            button.btn.btn-block.btn-primary(
              type="button",
              @click="$router.push({ name: 'sm-stores-manager-index' })"
            ) 取消
          .col-6
            button.btn.btn-block.btn-primary(
              type="button",
              @click="submitHandler()"
            ) 儲存送出
</template>

<script>
import { mapState } from 'vuex';
import { SM_STORES_MANAGER_INDEX } from '@/router/sm/stores-manager';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'StoresManagerSaEdit',
  components: {
    ProfilePhotoSticker
  },
  props: {
    sa_info: {
      type: Object,
      required: true
    },
    store_id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      nowSelectStatus: null,
      selectSa: null
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '請稍候，\n載入中',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('toggleLoading', false);
    vm.$store.dispatch('sm_stores_manager/getStorePersonnelHandler', {
      sa_id: vm.sa_info.sa_id,
      store_id: vm.store_id
    })
      .then(() => {
        vm.$swal.close();
      });
  },
  methods: {
    // 送出表單
    async submitHandler() {
      const vm = this;

      if (!vm.nowSelectStatus) {
        vm.$swal.fire({
          icon: 'error',
          title: '請選擇欲變更CA狀態'
        });
        return;
      }

      if (!vm.selectSa) {
        vm.$swal.fire({
          icon: 'error',
          title: '請選擇欲轉移客戶的目標CA'
        });
        return;
      }

      if (vm.sa_info.sa_id === vm.selectSa.sa_id) {
        vm.$swal.fire({
          icon: 'error',
          title: '移轉客戶的目標CA不可選則自己'
        });
        return;
      }

      vm.$swal.fire({
        title: '請稍候，\n表單送出中',
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      vm.$store.dispatch('sm_stores_manager/updateSaHandler', {
        sa_id: vm.sa_info.sa_id,
        heir_sa_id: vm.selectSa.sa_id,
        in_service_status: vm.nowSelectStatus
      }).then(() => {
        vm.$swal.close();
        vm.$snotify.success(null, '編輯成功');
        vm.$store.commit('sm_stores_manager/resetHandler');
        vm.$router.push({
          name: SM_STORES_MANAGER_INDEX
        });
      });
    }
  },
  computed: {
    ...mapState({
      storePersonnel: (state) => state.sm_stores_manager.storePersonnel
    })
  }
};
</script>

<style>

</style>
